import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAgGridApi } from "tap/components/AGGrid/hooks.js";
import { usePMXDeliveriesGridUtils } from "./utils/gridUtils";
import { usePMXDeliveriesData } from "../../hooks/usePMXDeliveriesData";
import DataGrid from "@dtci/spellbook/DataGrid";
import styles from "../../../../components/AGGrid/details-table.module.scss";

/**
 * PMX Deliveries Grid - Displays PMX deliveries in a read-only data grid.
 */
export const PMXDeliveriesGrid = () => {
  const agGridApi = useAgGridApi();
  const { deliveries, refreshPMXDeliveries } = useSelector(
    (s) => s.pmxDeliveries,
  );
  const {
    fetchPMXDeliveries,
    updatePMXDeliveries,
    pmxDeliveriesRange,
    filterForm,
  } = usePMXDeliveriesData();

  const { columns } = usePMXDeliveriesGridUtils({ columnHandlers: [] });

  const refreshList = async () => {
    const data = await fetchPMXDeliveries(pmxDeliveriesRange, filterForm);
    if (data) {
      updatePMXDeliveries({
        deliveries: data?.content,
        totalPages: data?.totalPages,
        totalItems: data?.totalElements,
        currentPage: data?.pageable?.pageNumber,
      });
    }
  };

  useEffect(() => {
    if (refreshPMXDeliveries) {
      refreshList();
      updatePMXDeliveries({ refreshPMXDeliveries: false });
    }
  }, [refreshPMXDeliveries]);

  return (
    <DataGrid
      className={styles.dataGrid}
      autoSizing
      agGrid={{
        ref: agGridApi.AgGridApiRef,
        rowData: deliveries ?? [],
        suppressColumnStateReset: true,
        headerHeight: 45,
        defaultColDef: {
          wrapText: true,
          autoHeight: true,
          resizable: true,
          suppressHeaderMenuButton: true,
          cellStyle: {
            paddingTop: "10px",
            paddingBottom: "10px",
            wordBreak: "break-word",
          },
        },
      }}
      bordered="none"
      columnDefs={columns}
      sortable={false}
      striped
      noResultsMessage={"No PMX deliveries Found"}
    />
  );
};
